import React, { Component, Fragment } from "react";

import Auth from "../../services/authService";
import UserProfileService from "../../services/userProfileService";
import LoadingSpinner from "../../components/loader/LoadingSpinner";
import { toast } from "react-toastify";

const user = Auth.getCurrentUser();

export default class userProfileInfo extends Component {
    state = {
        isLoading: false,
        address: "در حال بارگذاری",
        mobile: "در حال بارگذاری",
        nationalCode: "در حال بارگذاری",
        tel: "در حال بارگذاری",
        email: "در حال بارگذاری",
    };

    async componentDidMount() {
        try {
            const result = await UserProfileService.getUserHmaUserProfile(
                user.nameid
            );

            const state = { ...this.state };
            state.address = result.data.address ? result.data.address : "تعریف نشده";
            state.email = result.data.email ? result.data.email : "تعریف نشده";
            state.mobile = result.data.mobile ? result.data.mobile : "تعریف نشده";
            state.nationalCode = result.data.nationalCode ? result.data.nationalCode : "تعریف نشده";
            state.tel = result.data.tel ? result.data.tel : "تعریف نشده";
            const isLoading = true;
            state.isLoading = isLoading;
            this.setState(state);
        } catch (ex) {
            if (ex.code !== "ERR_NETWORK") {
                if (ex.code !== "ERR_BAD_REQUEST")
                    toast.error(ex.response.data.Message);
            }
        }
    }
    render() {
        return (
            <div id="userProfileInfo">
                {this.state.isLoading ? (<Fragment>
                    <div className="card">
                        <div className="body">
                            <i className="fa fa-map-marker"></i>
                            <p className="d-flex justify-content-center align-items-center p-2">{this.state.address}</p>
                            <hr />
                            <i className="fa fa-envelope"></i>
                            <p className="d-flex justify-content-center align-items-center p-2">{this.state.email}</p>
                            <hr />
                            <i className="fa fa-phone-square" aria-hidden="true"></i>
                            <p className="d-flex justify-content-center align-items-center p-2">{this.state.mobile}</p>
                            <hr />
                            <div >
                                <i className="fa fa-address-card m-2"></i>
                                کد ملی
                            </div>
                            <p className="d-flex justify-content-center align-items-center p-2">{this.state.nationalCode}</p>
                        </div>
                    </div>
                </Fragment>) : (<LoadingSpinner />)}
            </div>
        );
    }
}
